import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AgGridService } from "../ag-grid/ag-grid.service";
import { StorageService } from "../../services/storage.service";
import {AgGridI,AgGridPaginationConfig,PaginationBaseModel,TablePaginationModel,} from "./ag-grid.model";
import { ColDef, ColumnApi, ColumnResizedEvent, DragStoppedEvent, GridApi, RowClassRules, RowHeightParams, SelectionChangedEvent } from "ag-grid-community";
import { Subscription, catchError } from "rxjs";
import { AgCustomHeaderComponent } from "./ag-custom-header/ag-custom-header.component";
import {ListManagerService} from "../../../components/list-manager/list-manager.service";
import { Router } from "@angular/router";
import { TabsService } from "../tabs/tabs.service";
import { Result } from "../../model/response.model";
import { CategoryService } from "../../services/category.service";
import { GridName } from "../../model/ag-grid-common-constant.model";
import { TabNames } from "../../model/enum";
declare var window: any;

@Component({
  selector: "app-ag-grid",
  templateUrl: "./ag-grid.component.html",
  styleUrls: ["./ag-grid.component.scss"],
})
export class AgGridComponent implements OnInit {
  @Input() dataModel: AgGridI;
  @Input() getRowStyle: any;
 // @Input() getRowHeight = 32;

  
  agGridPaginationConfig = new AgGridPaginationConfig();
  isLoading: boolean = false;
  subscription: Subscription;
  deviceWidth: any;
  paginationBaseModel = new PaginationBaseModel();
  tablePaginationModel = new TablePaginationModel();
  currentTab: string;
  AgGridDataModelTemplate: any[] = [];

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    resizable: true,
  };
  public components: {
    [p: string]: any;
  } = {
    agColumnHeader: AgCustomHeaderComponent,
  };
  overlayNoRowsTemplate ='<div class="ag-overlay-no-rows-center">No Records Available</div>';

    @Output() onEditIconClick: EventEmitter<any> = new EventEmitter();
    @Output() onDeleteIconClick: EventEmitter<any> = new EventEmitter();
    @Output() gridReady: EventEmitter<any> = new EventEmitter();
    @Output() onPagination: EventEmitter<any> = new EventEmitter();
    @Output() onTextCellClick: EventEmitter<any> = new EventEmitter();

    isInitialCall:boolean = false;
    enumTabNames            = TabNames;

  constructor(
    public agGridService: AgGridService,
    public storageService: StorageService,
    public listManagerService :ListManagerService,
    public route: Router,
    public tabService: TabsService,
    public  categoryService: CategoryService,  
  ) {}

  ngOnInit(): void {
    this.subscription =  this.tabService.currentTab.subscribe(res => {
      if (res) {
        this.currentTab = res
      }
    })

    this.subscription =  this.agGridService.agGridPaginationConfigRes.subscribe((result) => {
      if (result) {this.agGridPaginationConfig = result;}
    });
    this.deviceWidth = window.innerWidth;
    console.log(this.route.url);
  }
  getAllTemplateListData(){
    this.agGridPaginationConfig.rows = [];
    this.isLoading = true;
    this.categoryService.getAllTemplateList(this.paginationBaseModel).pipe(catchError((err) => this.handleError(err)))?.subscribe((data: Result) => {
        if (data.isSuccess === true) {
          this.agGridService.agGridPaginationConfigRes.next(this.agGridService.updateTableData(data));
          this.isLoading = false;
          this.agGridService.getGridApi()?.showNoRowsOverlay();
          this.agGridService.selectionChanged?.next(this.agGridService.getGridApi()?.getSelectedRows())
        }
      });
  }
 

  getRowHeight(params: RowHeightParams): number {
    const columnDefs = params?.columnApi?.getAllColumns();
    const colId = columnDefs?.find(col => col.getColDef().field === 'description')?.getColId();
  
    return params?.data?.mailingListId || colId === 'description' ? 45 : 32;
  }
  
    
  public rowClassRules: RowClassRules = {
    'border-color': (params) => !params.data.mailingListId && this.route.url !== this.enumTabNames.SNIPPET_LIST
  };
  paginationCall(){
    this.subscription = this.agGridService.getPaginationData().subscribe(res => {
      if(res){
        this.storageService.store(GridName.AG_GRID_PAGINATIONMODEL,undefined);
        this.tablePaginationModel = res; 
        if (this.route.url.includes(this.enumTabNames.LIST_MANAGER_INFO)){ 
          const id = this.route.url.split('/').pop();
          this.tablePaginationModel.id = id;
        }
         this.onPagination.emit(this.tablePaginationModel);
         this.isInitialCall = true
          }
    })
    this.agGridService.tablePaginationData.subscribe(res => {
      if(res){
        this.storageService.store(GridName.AG_GRID_PAGINATIONMODEL,undefined)
        this.tablePaginationModel = res; 
        setTimeout(() => {
          this.onPagination.emit(this.tablePaginationModel);
        }, 100);
      this.isInitialCall = true
          }
    })
  
  }
    
  async onGridReady(params) {
    // params.api.addEventListener('editIconClick', this.handleEditIconClick.bind(this));
    // window.addEventListener('editIconClick', this.handleEditIconClick.bind(this));
    document.addEventListener('editIconClick', this.handleEditIconClick.bind(this));
    document.addEventListener('deleteIconClick', this.handleDeleteIconClick.bind(this));
    document.addEventListener('textCellClick', this.handleTextCellClick.bind(this));

    
    this.agGridService.setGridApi(params.api);
    this.agGridService.setGridColumnApi(params.columnApi);
    this.gridReady.emit(params);
    await this.paginationCall();


  }
  handleEditIconClick(event: any): void {
    if(event != undefined)
    this.onEditIconClick.emit(event?.detail?.data);
  }
  handleDeleteIconClick(event: any): void {
    if(event != undefined)
    this.onDeleteIconClick.emit(event?.detail?.data);
  }
  handleTextCellClick(event: any): void {
    if(event != undefined)
    this.onTextCellClick.emit(event.detail.data);
  }


  //#region onSelectionChanged
  onSelectionChanged(event: SelectionChangedEvent) {
    this.agGridService.selectionChanged.next(event);
  }
  onDragStopped(event: DragStoppedEvent) {
   // this.agGridService.onColumnDragStopped.next(event);
  }
  onGridSizeChanged($event) {}
  onFirstDataRendered(params: { api: GridApi; columnApi: ColumnApi }) {
    this.agGridService.saveColumnState(params.columnApi);
  }
  onRowClicked(params){
   console.log(params);
  }
  onColumnResized(event: ColumnResizedEvent) {
    if(event.source == 'uiColumnDragged'){
    window.colState = event.columnApi.getColumnState();
    this.storageService.store(this.dataModel.storageName, window.colState);
  }
  }

  columnMoved(event) {
    window.colState = event.columnApi.getColumnState(); 
    this.storageService.store(this.dataModel.storageName, window.colState);
  }
  onPageNumberChanged(index) {
    this.agGridPaginationConfig.currentPageNumber = index;
    this.tablePaginationModel.pageSize =  this.agGridPaginationConfig.pageSize;
    this.tablePaginationModel.pageNumber =  this.agGridPaginationConfig.currentPageNumber;
    this.tablePaginationModel.getAll =this.agGridPaginationConfig.pageSize == 1 ? true : false,
    this.onPagination.emit(this.tablePaginationModel);
  }

  onPageChanged(pageNum: number) {
    if(this.route.url?.includes(this.enumTabNames.LIST_MANAGER_INFO)){
     if(this.tablePaginationModel.pageNumber == pageNum)
      return
    }
    this.agGridService.onPageChanged(pageNum);
  //  this.initDatatable();
  this.onPageNumberChanged(pageNum)
  }
  onPageSizeChange(pageSize: number) {
    this.agGridService.onPageSizeChanged(pageSize);
   // this.initDatatable();
   this.onPageSizeChanged(pageSize)
  }
  onPageSizeChanged(pageSize) {
    this.agGridPaginationConfig.pageSize = pageSize;
    this.tablePaginationModel.pageSize =  this.agGridPaginationConfig.pageSize;
    this.tablePaginationModel.pageNumber =  this.agGridPaginationConfig.currentPageNumber;
    this.tablePaginationModel.getAll =this.agGridPaginationConfig.pageSize == 1 ? true : false,
    this.onPagination.emit(this.tablePaginationModel);
}

  initDatatable(){
    this.paginationBaseModel = {
      sortColumn: "",
      sortDirection: "",
      pageNumber: this.agGridPaginationConfig.currentPageNumber,
      pageSize: this.agGridPaginationConfig.pageSize,
      searchText: this.agGridPaginationConfig.searchText,
      getAll: this.agGridPaginationConfig.pageSize == 1 ? true : false,
    };
    if(this.route.url?.includes(this.enumTabNames.LIST_MANAGER_INFO)){
      const id = this.route.url.split('/').pop();
      this.tablePaginationModel = {
        sortColumn: this.paginationBaseModel.sortColumn,
        sortDirection: this.paginationBaseModel.sortDirection,
        pageNumber: this.paginationBaseModel.pageNumber,
        pageSize: this.paginationBaseModel.pageSize,
        searchText: this.paginationBaseModel.searchText,
        getAll: this.paginationBaseModel.getAll,
        id: id
    };
  }
  }
  ngOnDestroy() {
    if (this.subscription != undefined) {
      this.subscription.unsubscribe();
    }
  }
  handleError(err: any): any {
    console.log(err);
  }

  updateServersidePaginationData(total,totalRecords) {
    this.agGridPaginationConfig.totalRecords = totalRecords
  }

}

export { AgGridI };
